import { CatalogQueryParam } from "@/lib/types/catalogPage";
import { P2 } from "@/lib/ui/components/Typography";
import { PlusIcon, MinusIcon } from "@/lib/ui/icons";
import { useTranslation } from "next-i18next";
import { FC, ReactNode, useState } from "react";
import { CatalogCheckboxBlock } from "../CatalogFilter/CatalogCheckboxBlock";
import styles from "./CatalogFilterModal.module.scss";
import { IValueLabel } from "@/lib/types/mainPage";


export const OptionsBlock: FC<{
  items: IValueLabel[];
  children?: ReactNode;
  catalogQuery: CatalogQueryParam;
  title?: string;
}> = ({ items, catalogQuery, children, title }) => {

  const [shownCount, setShownCount] = useState(10);
  const { t } = useTranslation("index");
  const isTwoColumns = ["phuketBeaches", "samuiBeaches", "district", "facilities"].includes(catalogQuery);

  const hasExpandButton = items.length > 10;
  const isExpanded = shownCount === 10;
  
  return (
    <div className={styles.modal__filterBlock}>
      <P2 className={styles.modal__filterTitle}>{title || t(catalogQuery === "beachDistance" ? 'catalog.beachDistance' : catalogQuery)}</P2>
      <CatalogCheckboxBlock
        items={items.slice(0, shownCount)}
        isTwoColumns={isTwoColumns}
        catalogQuery={catalogQuery}
      />
      {hasExpandButton && (
        <button
          onClick={() => setShownCount((c) => (isExpanded ? items.length : 10))}
          className={styles.modal__expand}
        >
          <P2>{t(isExpanded ? "expand" : "collapse")}</P2>
          {isExpanded ? <PlusIcon /> : <MinusIcon />}
        </button>
      )}
      {children}
    </div>
  );
};
